<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <v-switch
          v-model="wonky"
          :label="wonky ? 'Wonky mode active' : 'Wonky mode disabled - probably for the best'"
          @update:model-value="toggleWonkyMode"
          hide-details
          class="my-0"
        ></v-switch>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn @click="logout" color="accent">Logout</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { auth, db } from '@/js/db'
import { collection, getDocs, query, updateDoc, where } from 'firebase/firestore'
import { signOut } from 'firebase/auth'

export default {
  name: 'user',
  data() {
    return {
      fsUser: null,
      user: null,
      wonky: null
    }
  },
  async created() {
    this.fsUser = auth.currentUser
    this.$store.commit('setPageTitle', this.fsUser.email)
    const userSnap = await getDocs(query(collection(db, 'users'), where('email', '==', this.fsUser.email)))
    this.user = userSnap.docs[0]
    this.wonky = this.user.data().wonkyMode
  },
  methods: {
    async toggleWonkyMode(boolean) {
      // the ref was captured in created(); the re-read this used to do was discarded
      await updateDoc(this.user.ref, {
        wonkyMode: boolean
      })
    },
    logout() {
      signOut(auth).then(
        () => {
          this.$router.push({ name: 'login' })
        },
        (err) => {
          console.log('Error signing out', err)
        }
      )
    }
  }
}
</script>
